import { render, staticRenderFns } from "./ConfigImpressaoNova.vue?vue&type=template&id=6d257b0c"
import script from "./ConfigImpressaoNova.vue?vue&type=script&lang=js"
export * from "./ConfigImpressaoNova.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports